import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";
import mentee1 from "../assets/mentee1.jpg";
import mentee2 from "../assets/mentee2.jpg";
import mentee3 from "../assets/mentee3.jpg";
import mentee4 from "../assets/mentee4.webp";
import mentee5 from "../assets/mentee5.jpeg";

const MenteeShowcase = () => {
  const [openBioIndex, setOpenBioIndex] = useState(null);
//   const [openImpactIndex, setOpenImpactIndex] = useState(null);

  const toggleBioDropdown = (index) => {
    setOpenBioIndex(openBioIndex === index ? null : index);
  };

//   const toggleImpactDropdown = (index) => {
//     setOpenImpactIndex(openImpactIndex === index ? null : index);
//   };

  const mentees = [
    {
      name: "Adeola Sarah Adebisi",
      image: mentee1,
      bio: "Adeola ADEBISI is an experienced finance and accounting professional with expertise in corporate finance and strategic management. As a chartered accountant (ICAN), she has worked across industries, gaining hands-on experience and driving excellence. With a strong leadership mindset, she is passionate about mentorship, professional growth, and continuous learning.",
    //   impact: "Her mentorship journey has led to significant career growth and industry recognition.",
    },
    {
      name: "Pamela Victor Ibitamuno",
      image: mentee2,
      bio: "Pamela Victor Ibitamuno is a lawyer and legal technologist with expertise in technology law, intellectual property, and cybersecurity law. Recognized as one of the 20 Nigerian Active Female Entrepreneurs in 2022, she is an ambassador for amplifying black voices. She has been on a mentorship journey with us for nearly three years.",
    //   impact: "Her journey has empowered her to drive change and advocate for economic and social justice in the UK and Africa.",
    },
    {
      name: "Chukwunenye Nelson Chineme",
      image: mentee4,
      bio: "Chukwunenye is the CEO of Orbs Technologies Limited and a graduate of Computer Science from one of Nigeria's best private universities. His strategic leadership and innovative business strategies have been remarkable.",
    //   impact: "His leadership at Orbs Technologies has driven significant growth and positioned the company as a leading tech firm in Lagos.",
    },
    {
      name: "Favour Ohagwa",
      image: mentee3,
      bio: "She is one of the most brilliant minds our company has worked with, excelling in her career as a chartered accountant and an aspiring master's student in Canada, working with one of the Big Four accounting firms.",
    //   impact: "Her excellence has been recognized industry-wide, making her a role model for aspiring professionals.",
    },
    {
      name: "Kathyrine Ezeilo",
      image: mentee5,
      bio: "Kathyrine is a 3rd-year student at Memorial University of Newfoundland, passionate about social justice and ethical discussions. She aspires to become a successful entrepreneur, establishing an orphanage and a foundation to support women and children affected by domestic violence.",
    //   impact: "Her vision for social change and entrepreneurial spirit have earned her recognition as a future leader in her field.",
    },
  ];

  return (
    <div className="container mx-auto px-6 py-16">
      {/* Hero Section */}
      <motion.section
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-gradient-to-r from-green-600 to-green-800 text-white py-28 rounded-3xl text-center"
      >
        <h1 className="text-4xl md:text-5xl font-bold">Mentee Showcase</h1>
        <p className="mt-4 text-xl md:text-2xl max-w-2xl mx-auto">
          Explore inspiring stories from our mentees and see the impact of our mentorship programs.
        </p>
      </motion.section>

      {/* Mentee Cards Grid */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-16 grid gap-8"
      >
        {mentees.map((mentee, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-xl p-8 flex flex-col md:flex-row items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            {/* Mentee Image */}
            <div className="md:w-1/3 flex justify-center">
              <img
                src={mentee.image}
                alt={mentee.name}
                className="w-48 h-48 rounded-full object-cover"
              />
            </div>

            {/* Mentee Details */}
            <div className="md:w-2/3 mt-6 md:mt-0 md:pl-8">
              <p className="text-sm uppercase text-gray-500 mb-1">Mentee Profile</p>
              <h3 className="text-2xl font-bold text-green-700">{mentee.name}</h3>

              {/* Bio Dropdown */}
              <div className="mt-4">
                <button
                  onClick={() => toggleBioDropdown(index)}
                  className="flex justify-between items-center w-full text-sm font-semibold text-green-700"
                >
                  {openBioIndex === index ? "Hide Bio" : "Show Bio"}
                  {openBioIndex === index ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                </button>
                <AnimatePresence>
                  {openBioIndex === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="mt-2 text-sm text-gray-700"
                    >
                      <p>{mentee.bio}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Impact Story Dropdown */}
              {/* <div className="mt-4">
                <button
                  onClick={() => toggleImpactDropdown(index)}
                  className="flex justify-between items-center w-full text-sm font-semibold text-green-700"
                >
                  {openImpactIndex === index ? "Hide Impact Story" : "Show Impact Story"}
                  {openImpactIndex === index ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                </button>
                <AnimatePresence>
                  {openImpactIndex === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="mt-2 text-sm text-gray-700"
                    >
                      <p>{mentee.impact}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div> */}
            </div>
          </motion.div>
        ))}
      </motion.section>
    </div>
  );
};

export default MenteeShowcase;
